import styled from "styled-components"


const OraclePanel = styled.div`

    color: ${({ theme }) => theme.inputPanelTextColor};
    background-color: ${({ theme }) => theme.inputPanelBackgroundColor};
    border: 1px solid ${({ theme }) => theme.inputPanelBorderColor};

	border-radius: 0.9em;
	font-size: 1.6em;
	margin: 1px;
	overflow: hidden;
	padding-bottom: 0em;
	outline: none;
	font-weight: normal;
	text-decoration: none;
	text-align: right;
	width: 80%;

	display: flex;
    flex-direction: row;
    justify-content: right;

    :hover {
	    border: 1px solid ${({ theme }) => theme.inputPanelBorderColorHover};
    }


	/* Tablets */
	@media (max-width: 1400px) {
		font-size: 1.4em;
		padding: 0.em;
	}

	/* Mobiles */
	@media (max-width: 640px) {
		font-size: 1.2em;
		padding: 0.em;
	}
`;

export default OraclePanel;